export const designTokens = {
  fontFamily:
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as const,

  fontSize: {
    xxs: "11px" as const,
    xs: "12px" as const,
    "2xs": "13px" as const,
    sm: "14px" as const,
    base: "16px" as const,
    lg: "18px" as const,
    xl: "20px" as const,
    "2xl": "24px" as const,
    "3xl": "30px" as const,
    "4xl": "48px" as const,
  },

  fontWeight: {
    normal: 400 as const,
    medium: 500 as const,
    semibold: 600 as const,
    bold: 700 as const,
  },

  lineHeight: {
    tight: 1.25 as const,
    normal: 1.5 as const,
    relaxed: 1.625 as const,
  },

  letterSpacing: {
    tight: "0.02em" as const,
    wide: "0.05em" as const,
  },

  accent: {
    50: "#e6fffa" as const,
    100: "#b2f5ea" as const,
    200: "#81e6d9" as const,
    300: "#4fd1c5" as const,
    400: "#38b2ac" as const,
    500: "#039fb8" as const,
    600: "#028a9f" as const,
    700: "#026e7f" as const,
  },

  primary: {
    50: "#f0f4f8" as const,
    100: "#d9e2ec" as const,
    200: "#bcccdc" as const,
    300: "#9fb3c8" as const,
    400: "#829ab1" as const,
    500: "#627d98" as const,
    600: "#486581" as const,
    700: "#334e68" as const,
    800: "#243b53" as const,
    900: "#102a43" as const,
  },

  neutral: {
    white: "#ffffff" as const,
    50: "#fafafa" as const,
    100: "#f5f5f5" as const,
    200: "#e5e5e5" as const,
    300: "#d4d4d4" as const,
    400: "#a3a3a3" as const,
    500: "#737373" as const,
    600: "#525252" as const,
    700: "#404040" as const,
    800: "#262626" as const,
    900: "#171717" as const,
  },

  semantic: {
    success: "#10b981" as const,
    successLight: "#d1fae5" as const,
    successDark: "#065f46" as const,
    error: "#bc2f32" as const,
    errorLight: "#fee2e2" as const,
    errorHover: "#dc2626" as const,
    errorActive: "#b91c1c" as const,
    warning: "#f59e0b" as const,
    warningLight: "#fef3c7" as const,
    warningDark: "#92400e" as const,
    info: "#3b82f6" as const,
    infoLight: "#dbeafe" as const,
    warningBorder: "#E8B04B" as const,
    warningBackground: "#FFF6E5" as const,
    warningBackgroundStrong: "#FFE0A0" as const,
    warningText: "#7A4F00" as const,
  },

  spacing: {
    1: "4px" as const,
    2: "8px" as const,
    3: "12px" as const,
    4: "16px" as const,
    5: "20px" as const,
    6: "24px" as const,
    8: "32px" as const,
    10: "40px" as const,
    12: "48px" as const,
    16: "64px" as const,
    20: "80px" as const,
    24: "96px" as const,
    32: "128px" as const,
    40: "160px" as const,
  },

  borderRadius: {
    sm: "4px" as const,
    md: "8px" as const,
    lg: "12px" as const,
    xl: "16px" as const,
    "2xl": "20px" as const,
    full: "9999px" as const,
  },

  shadow: {
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)" as const,
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)" as const,
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)" as const,
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)" as const,
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)" as const,
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)" as const,
  },

  transition: {
    fast: "150ms ease" as const,
    base: "200ms ease" as const,
    slow: "300ms ease" as const,
  },

  controlHeight: {
    sm: "32px" as const,
    md: "44px" as const,
  },

  avatarSize: {
    sm: 28 as const,
    md: 36 as const,
    lg: 40 as const,
  },

  iconSize: {
    xs: "14px" as const,
    sm: "16px" as const,
    md: "22px" as const,
    lg: "28px" as const,
  },

  drawerWidth: {
    mobile: "280px" as const,
  },

  nav: {
    collapsed: "82px" as const,
    expanded: "240px" as const,
  },

  overlay: {
    light: "rgba(255, 255, 255, 0.8)" as const,
    dark: "rgba(0, 0, 0, 0.5)" as const,
  },

  breakpoint: {
    sm: "480px" as const,
    md: "640px" as const,
    lg: "768px" as const,
    xl: "1024px" as const,
    "2xl": "1200px" as const,
  },

  card: {
    fixedTitleSectionHeight: "66px" as const,
    fixedDescriptionMinHeight: "63px" as const,
  },
} as const;

export default designTokens;
